import type { ComponentProps } from 'react';
import React from 'react';
import styled from '@emotion/styled';
import type { AlignItemsProps, DisplayProps } from 'styled-system';
import { alignItems, color, display, themeGet } from 'styled-system';

import { Link as CommonLink } from 'common/components/Link';
import { LinkRegularLR3 } from 'common/components/Typography';
import type { TextDecorationProps } from 'common/theme/system-utilities';
import { textDecoration } from 'common/theme/system-utilities';
import type { PropsWithRequiredChildren } from 'common/types/React';

const BaseLink = styled(LinkRegularLR3)<DisplayProps & AlignItemsProps & TextDecorationProps>`
  ${display};
  ${alignItems};
  ${textDecoration};

  &:active,
  &:hover,
  &:focus {
    ${color};
    text-decoration: underline;
    text-decoration-color: ${themeGet('colors.sys.neutral.text.inverted')};
  }
`;

const linkStyles: ComponentProps<typeof BaseLink> = {
  as: CommonLink,
  py: ['sp_4', null, 'sp_6'],
  color: 'sys.neutral.text.inverted',
  display: 'flex',
  alignItems: 'center',
  textDecoration: 'none',
};

type LinkProps = ComponentProps<typeof BaseLink> & ComponentProps<typeof CommonLink>;

const Link = ({ children, ...props }: PropsWithRequiredChildren<LinkProps>) => (
  <BaseLink {...linkStyles} {...props}>
    {children}
  </BaseLink>
);

export default Link;
